import { register } from "./registry";

register((root) => {
  const table = root.querySelector<HTMLTableElement>("table#vcts-table");
  if (!table || table.dataset.vctsBound === "1") return;
  table.dataset.vctsBound = "1";

  const tbody = table.tBodies[0];
  if (!tbody) return;
  const tpl = table.querySelector<HTMLTemplateElement>("template#vcts-row-template");

  const syncRow = (row: HTMLTableRowElement) => {
    const docSelect = row.querySelector<HTMLSelectElement>("select.vcts-doc-type");
    const otherDoc = row.querySelector<HTMLInputElement>("input.vcts-other-doc");
    const customOffice = row.querySelector<HTMLSelectElement>("select.vcts-customs-office");
    if (!docSelect) return;

    const val = (docSelect.value || "").toLowerCase();
    const isOther = val === "other" || val === "others";
    const isPragyapan = val === "pragyapan";

    if (otherDoc) {
      otherDoc.disabled = !isOther;
      if (!isOther) otherDoc.value = "";
    }

    if (customOffice) {
      customOffice.disabled = !isPragyapan;
      if (!isPragyapan) customOffice.value = "";
    }
  };

  const reindex = () => {
    Array.from(tbody.rows).forEach((row, idx) => {
      const sn = row.querySelector(".vcts-sn");
      if (sn) sn.textContent = String(idx + 1);
      row.querySelectorAll<HTMLInputElement | HTMLSelectElement>("input, select").forEach((input) => {
        const name = input.getAttribute("name");
        if (name && name.includes("Form.Vcts[")) {
          input.name = name.replace(/Form\.Vcts\[\d+\]/, `Form.Vcts[${idx}]`);
        }
      });
    });
  };

  // Sync initial rows
  Array.from(tbody.rows).forEach(syncRow);

  table.addEventListener("change", (e) => {
    const target = e.target as HTMLElement;
    if (target.matches("select.vcts-doc-type")) {
      const row = target.closest("tr");
      if (row) {
        syncRow(row);
        const val = (target as HTMLSelectElement).value.toLowerCase();
        if (val === "other") {
          row.querySelector<HTMLInputElement>("input.vcts-other-doc")?.focus();
        } else if (val === "pragyapan") {
          row.querySelector<HTMLSelectElement>("select.vcts-customs-office")?.focus();
        }
      }
    }
  });

  table.addEventListener("click", (e) => {
    const target = e.target as HTMLElement;
    const delBtn = target.closest<HTMLElement>(".cb-btn-row-del, [data-vcts-row-del]");
    if (delBtn) {
      e.preventDefault();
      const tr = delBtn.closest("tr");
      if (tr && tbody.rows.length > 1) {
        tr.remove();
        reindex();
      } else if (tr && tbody.rows.length === 1) {
        tr.querySelectorAll<HTMLInputElement | HTMLSelectElement>("input, select").forEach((inp) => {
          if (inp instanceof HTMLInputElement) inp.value = "";
          else if (inp instanceof HTMLSelectElement) inp.selectedIndex = 0;
        });
        syncRow(tr);
      }
    }
  });

  const addBtn = document.getElementById("btn-add-vcts-row");
  addBtn?.addEventListener("click", (e) => {
    e.preventDefault();
    if (!tpl) return;
    const clone = tpl.content.firstElementChild?.cloneNode(true) as HTMLTableRowElement | null;
    if (clone) {
      tbody.appendChild(clone);
      reindex();
      syncRow(clone);
      clone.querySelector<HTMLSelectElement>("select.vcts-doc-type")?.focus();
    }
  });

  const delAllBtn = document.getElementById("btn-del-all-vcts");
  delAllBtn?.addEventListener("click", (e) => {
    e.preventDefault();
    while (tbody.rows.length > 1) {
      tbody.lastElementChild?.remove();
    }
    const tr = tbody.rows[0];
    if (tbody.rows.length === 1 && tr) {
      tr.querySelectorAll<HTMLInputElement | HTMLSelectElement>("input, select").forEach((inp) => {
        if (inp instanceof HTMLInputElement) inp.value = "";
        else if (inp instanceof HTMLSelectElement) inp.selectedIndex = 0;
      });
      syncRow(tr);
    }
    reindex();
  });
});
